<template>
  <div class="tooltip-container ">
    <div @mouseenter="showTooltip = true" @mouseleave="showTooltip = false" class="trigger flex items-center justify-center">
      <slot name="trigger">
        <i class="pi pi-info-circle" style="font-size: 1rem; cursor: pointer;"></i>
      </slot>
    </div>

    <transition name="fade">
      <div v-if="showTooltip" class="tooltip-content" :class="position">
        <slot>Default tooltip content</slot>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'InfoTooltip',
  props: {
    position: {
      type: String,
      default: 'right',
      validator: (value: string) => ['top', 'right', 'bottom', 'left'].includes(value)
    },
  },
  setup() {
    const showTooltip = ref(false);
    
    return {
      showTooltip
    };
  }
});
</script>

<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-content {
  position: absolute;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  padding: 12px;
  min-width: 250px;
  z-index: 1000;
  max-width: 350px;
}

.tooltip-content.top {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-8px);
}

.tooltip-content.right {
  left: 100%;
  top: 50%;
  transform: translateY(-50%) translateX(8px);
}

.tooltip-content.bottom {
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(8px);
}

.tooltip-content.left {
  right: 100%;
  top: 50%;
  transform: translateY(-50%) translateX(-8px);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style> 